import { getRequest, postRequest } from '../baseRequest'
import request from '@/api/index'
import { filterEmptyParams } from '@/utils/formatObject'

// 查询用户列表
export const listUser = (data) => postRequest('/mange/user/page', filterEmptyParams(data))

// 查询用户列表
export const accountTypeList = () => getRequest('/mange/user/accountType')

// 查询用户详细
export const getUser = (id) => getRequest('/mange/user/' + id)

// 新增用户
export const addUser = (data) => postRequest('/mange/user/add', data)

// 修改用户
export const updateUser = (data) => postRequest('/mange/user/update', data)

// 删除用户
export const delUser = (id) => postRequest('/mange/user/delete/' + id)

// 禁用用户
export const deactiveUser = (id) => postRequest('/mange/user/deactiveUser/' + id)

// 启用用户
export const activeUser = (id) => postRequest('/mange/user/activeUser/' + id)

// 查询用户详细
export const getUserInfo = () => getRequest('user/info')

// 下载导入用户账号模板
export const getImportTemplate = (params) => {
  return request({
    url: '/mange/user/file/getImportTemplate',
    method: 'get',
    params: params,
    responseType: 'blob'
  })
}

// 导入用户账号
export function importUser(params, onUploadProgress) {
  console.log('api', params)
  const file = params.data.file
  let data = new FormData() // 实例化一个formData，用来做文件上传
  data.append('file', file)
  return request({
    url: `mange/user/file/batchRegister`,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'post',
    data,
    onUploadProgress
  })
}
